import { Image } from 'antd'
import React from 'react'
import { StaticImages } from '../Utils/StaticImages'

function LazyLoading() {
  return (
    <div className='add_background_Color flex justify-center items-center h-screen w-screen'>
      <Image
        src={StaticImages.AuthLogo.Icon}
        preview={false}
        draggable={false}
        height={150}
      />
    </div>
  )
}

export default LazyLoading
